import classNamesMerge, { Argument } from 'classnames';

const classNames = (...classes: Argument[]): string => {
  return classNamesMerge(...classes.slice(0, classes.length - 1));
};

export default classNames;
